import type { AccountInfo } from "@azure/msal-browser";
import { ref, shallowRef } from "vue";

// Shared session identity for the MSAL flows (login/redirect/restore/auth-check).
// Exposed as refs so cross-module consumers (IcsLoginView, notificationsStore,
// EntraProvider) read them reactively. auth.ts re-exports everything from here,
// so the established import surface @/helpers/auth stays unchanged.

export const userAzureId = ref("");
/** OID (object id) from the JWT, used for the SignalR group user_{oid} so backend and frontend match. */
export const userOid = ref("");

// shallowRef, not ref, so the stored AccountInfo keeps its object identity - a
// deep ref proxy would break toBe checks and MSAL internals that compare accounts.
export const userAccount = shallowRef<AccountInfo | null>(null);

/** Set the current account. Writing userAccount.value notifies all reactive readers. */
export function setUserAccount (account: AccountInfo | null): void {
  userAccount.value = account;
}
